export const snackConfig = (msg: string) => ({
    special: true,
    description: msg,
    style: 'danger-2-text',
    timeout: 5000,
});
